// extracted by mini-css-extract-plugin
export default {"wrapper":"sD-z","viewport":"tD-z","container":"uD-z","slide":"vD-z"};